import axios from "axios";
import { useUserStore } from '@/store/user';
import router from '@/router';
import { refreshToken, logout } from '@/utils/auth';

const api = axios.create({
    // 正式环境
    baseURL: '/api',
    // 测试环境
    // baseURL: 'http://192.168.0.105/api',
    timeout: 5000,
    withCredentials: true,
    headers: {
        'Content-Type': 'application/json',
    }
});

// 响应拦截器
let isRefreshing = false;
let failedQueue: { resolve: (token: string | null) => void; reject: (error: any) => void }[] = [];

const processQueue = (error: any, token = null) => {
  failedQueue.forEach(prom => {
    if (error) {
      prom.reject(error);
    } else {
      prom.resolve(token);
    }
  });
  
  failedQueue = [];
};

api.interceptors.response.use(
  (response) => {
    return response;
  },
  async (error) => {
    const originalRequest = error.config;
    
    // 匹配登录接口的URL
    const isLoginRequest = originalRequest.url?.includes('/login/');
    if (error.response?.status === 401 && isLoginRequest) {
      return Promise.reject(error); // 直接抛出错误，让登录组件处理
    }
    
    // 关键修改2：非登录接口的401才进入刷新流程
    if (error.response?.status !== 401 || originalRequest._retry) {
      return Promise.reject(error);
    }
    
    // 如果正在刷新token，将请求加入队列
    if (isRefreshing) {
      return new Promise((resolve, reject) => {
        failedQueue.push({ resolve, reject });
      })
        .then(token => {
          originalRequest.headers['Authorization'] = `Bearer ${token}`;
          return api(originalRequest);
        })
        .catch(err => {
          return Promise.reject(err);
        });
    }
    
    originalRequest._retry = true;
    isRefreshing = true;
    
    // 尝试刷新token
    try {
      await refreshToken();
      processQueue(null);
      // 重试原始请求
      return api(originalRequest);
    } catch (refreshError) {
      // 刷新token失败，需要重新登录
      processQueue(refreshError, null);
      logout();
      // 跳转到登录页
      window.location.href = '/login';
      return Promise.reject(refreshError);
    } finally {
      isRefreshing = false;
    }
  }
);

export default api;
